import { Reveal, SectionHead } from "./Reveal";

const STATS = [
    { pre: "More than", value: "1 in 4", text: "adults 65 and older fall each year.", source: "Source: CDC" },
    { pre: "About", value: "4.5 million", text: "emergency department visits each year are for falls by older adults.", source: "Source: CDC" },
    { pre: "", value: "88%", text: "of hip fracture emergency visits and hospital stays are caused by falls.", source: "Source: CDC" },
];

export default function WhyItMatters() {
    return (
        <section id="why-it-matters" className="scroll-mt-24 py-10 sm:py-14 lg:py-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="The stakes" title="Why it matters" />
                </Reveal>
                <div className="mt-8 grid sm:mt-12 gap-6 md:grid-cols-3">
                    {STATS.map((s, i) => (
                        <Reveal key={s.value} delay={i * 0.1} className="h-full">
                            <div className="h-full rounded-3xl border border-clay bg-white p-5 sm:p-8" data-testid={`stat-card-${i + 1}`}>
                                <p className="min-h-[1.5em] text-base font-bold uppercase tracking-wide text-teal-800">{s.pre || "\u00A0"}</p>
                                <p className="mt-1 font-display text-5xl font-black tracking-tight text-ink lg:text-[3.2rem] lg:leading-[1.05]">
                                    {s.value}
                                </p>
                                <p className="mt-4 text-lg leading-relaxed text-ink-soft">{s.text}</p>
                                <span className="mt-6 block h-1 w-12 rounded-full bg-brand-amber" aria-hidden="true" />
                                <p className="mt-3 text-base font-semibold text-ink-soft">{s.source}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.15}>
                    <p className="mt-8 max-w-3xl sm:mt-12 text-lg leading-relaxed text-ink">
                        Falls are the leading cause of injury for Americans 65 and older (National Council on
                        Aging). Even a fall without an injury can leave someone afraid to move, and moving less
                        raises the risk of the next fall.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}